module.exports = __webpack_public_path__ + "static/img/Lachlan-Gulbin.e6969f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Lachlan-Gulbin.jpg
// module id = doa8
// module chunks = 0